const _center = "center"
const _top = "top"
const _right = "right"
const _bottom = "bottom"
const _left = "left"
const config = { "center": _center, "top": _top, "right": _right, "bottom": _bottom, "left": _left, "top-right": "top right", "bottom-right": "bottom right", "bottom-left": "bottom left", "top-left": "top left",  }
export { config as default, _center, _top, _right, _bottom, _left }